module.exports = __webpack_public_path__ + "static/media/share.c1368562.png";